import React from 'react';
import { FiAlertTriangle, FiShield } from 'react-icons/fi';
import './KycRequiredModal.css';

const KycRequiredModal = ({
  open,
  message,
  roleLabel,
  kycStatus,
  onClose,
  onGoToKyc,
}) => {
  if (!open) return null;

  const isPending = kycStatus === 'pending';

  return (
    <div className="kyc-required-overlay" onClick={onClose} role="presentation">
      <div
        className="kyc-required-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="kyc-required-title"
        aria-modal="true"
      >
        <div className="kyc-required-icon">
          {isPending ? <FiAlertTriangle /> : <FiShield />}
        </div>
        <h3 id="kyc-required-title">KYC Verification Required</h3>
        <p className="kyc-required-message">
          {message ||
            'You must complete KYC verification before submitting a property listing.'}
        </p>
        {roleLabel && (
          <p className="kyc-required-role">
            Role: <strong>{roleLabel}</strong>
          </p>
        )}
        <div className="kyc-required-actions">
          {!isPending && (
            <button type="button" className="kyc-required-primary" onClick={onGoToKyc}>
              <FiShield /> Complete KYC Verification
            </button>
          )}
          <button type="button" className="kyc-required-secondary" onClick={onClose}>
            {isPending ? 'OK' : 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default KycRequiredModal;
